import { jsx as _jsx } from "react/jsx-runtime";
import { Alert } from "@mui/material";
import { clientConfigFn } from "clientConfig";
const BankingCutoff = () => {
    return (_jsx(Alert, { severity: "warning", children: clientConfigFn().bankingCutOffWarning }));
};
export default BankingCutoff;
